import issueDescription from "./issue_description";
import reason from "./reason";

export default {
  issueDescription,
  reason,
  displayName: "Depr: Topic with Parameter with Any Value",
  order: 520,
};
